import { useCallback } from "react";

import { postHTML } from "@/lib/aws-amplify/storage";
import { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { HotelArticleUpdate_DesignPage_Mutation } from "./mutation";

type Props = {
	hotelID: string;
};

export const useHotelArticleUpdateMutation = ({ hotelID }: Props) => {
	const { mutationFunc } = useCustomMutation(HotelArticleUpdate_DesignPage_Mutation);

	const onUpdate = useCallback(
		async ({
			articleHTML,
			tags,
			tagsLocation,
		}: {
			articleHTML: string;
			tags: Array<string>;
			tagsLocation: Array<string>;
		}) => {
			const { s3Object } = await postHTML({
				html: articleHTML,
				lang: LangCode.Default,
				hotelID,
				resourceID: hotelID,
			});

			return await mutationFunc({
				variables: {
					input: {
						hotelID,
						article: s3Object,
						tags,
						tagsLocation,
					},
				},
			});
		},
		[hotelID, mutationFunc],
	);

	return {
		onUpdate,
	};
};
